export default "__VITE_ASSET__B4rY0ET4__"